import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import "./banner.css"

export default class Banner extends React.Component {

    render() {
        return (
            <div>
                <div className="grid">
                    <Grid fluid>
                        <Row id="mainHeader">
                            <Col lg={12}>
                                <img width="50" height="50" src="../assets/lockoinvest_sign_background.png" />
                                <div className="userName">
                                    <table>
                                        <tr>
                                            <td>
                                                <div className="headerInfo"><a className="headerLink" href="mailto:clients@astra-am.ru">clients@astra-am.ru</a></div>
                                            </td>
                                            <td>
                                                <span className="userIcon dx-icon-user"></span>
                                            </td>
                                            <td>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </div>
                <div className="techHeader">
                    <div className="techBorder">
                        <div className="techText">Уважаемые клиенты!</div>
                        <div className="techText">В данный момент на сайте ведутся технические работы, просим извинения за доставленные неудобства.</div>
                    </div>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/banner/banner.jsx